import { CalendarProvider } from './context';
import { SelectionProvider } from './selectionContext';
import { CalendarPage } from './page';
import { ErrorBoundary } from '../../components';

export const Calendar = () => (
  <ErrorBoundary translationNamespace="calendar">
    <CalendarProvider>
      <SelectionProvider>
        <CalendarPage />
      </SelectionProvider>
    </CalendarProvider>
  </ErrorBoundary>
);
